<template>
    <div class="sign-in-page">
        <h2 class="title">Sign in</h2>
        <b-button icon-left="google" type="is-info" @click="onSignInClick">
            Sign in with Google
        </b-button>
    </div>
</template>

<script>
import getGoogleOAuthUrl from '@/utils/getGoogleUrl'
import {mapActions} from 'vuex';
export default {
    name: "SignInPage",
    methods: {
        ...mapActions('Auth', [
            'oauth',
        ]),
        async onSignInClick() {
            const authUri = getGoogleOAuthUrl();
            window.location = authUri;
        }
    },
    async created() {
        const url = new URL(window.location.toString()).searchParams;
        const authCode = url.get("code");
        if (authCode) {
            await this.oauth(authCode);
            window.history.replaceState(null, '', location.pathname);
        }
    }
}
</script>

<style scoped>
    .sign-in-page {
        text-align: center;
    }
</style>